/* eslint-disable no-console */
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Input from '../Input';
import { Styled } from './styled';

const handleScriptLoad = (searchInputId,countryRule, onAddressSelected, setQuery) => {  
  const inputField = document.querySelector(`#${searchInputId}`);

  const autoComplete = new window.google.maps.places.Autocomplete(inputField, {
    componentRestrictions: { country: countryRule },
    fields: ['address_components', 'geometry'],
  });

  let city = '';
  let countryISOCode = '';
  let countryPostalName = '';
  let subpremise = '';
  let premise = '';
  let streetNumber = '';
  let route = '';
  let line1 = '';
  let line2 = '';
  let postcode = '';
  let state = '';

  const fillInAddress = async () => {
    const place = await autoComplete.getPlace();
    const geometry = place?.geometry?.location;

    place?.address_components?.forEach((component) => {
      const componentType = component.types[0];
      switch (componentType) {
        case 'subpremise':
          subpremise = component.long_name;
          break;
        case 'premise':
          premise = component.long_name;
          break;
        case 'street_number': {
          streetNumber = component.long_name;
          break;
        }
        case 'route': {
          route = component.long_name;
          break;
        }
        case 'postal_code': {
          postcode = component.long_name;
          break;
        }
        case 'postal_code_prefix': {
          postcode = component.long_name;
          break;
        }
        case 'postal_code_suffix': {
          postcode = `${postcode}-${component.long_name}`;
          break;
        }
        case 'locality':
          city = component.long_name;
          break;
        case 'postal_town':
          city = component.long_name;
          break;
        case 'administrative_area_level_1': {
          state = component.short_name;
          break;
        }
        case 'country':
          countryPostalName = component.long_name.toLocaleUpperCase();
          countryISOCode = component.short_name.toLocaleUpperCase();
          break;
          
        default:
          break;
      }
    });

    // create the lines
    line1 = [subpremise, premise].filter(Boolean).join(', ');
    if (!line1) {
      line1 = [streetNumber, route].filter(Boolean).join(' ');
    } else {
      line2 = [streetNumber, route].filter(Boolean).join(' ');
    }

    const display = `${[line1, line2].filter(Boolean).join(', ')},\n${city},\n${postcode}`;

    onAddressSelected({
      city,
      country: countryISOCode || countryPostalName,
      countryISOCode,
      countryPostalName,
      display,
      line1,
      line2,
      locality: city,
      longitude: geometry?.lng(),
      latitude: geometry?.lat(),
      postcode,
    });

    setQuery(display);
  };

  autoComplete.addListener('place_changed', fillInAddress);
  return autoComplete;
};

export function AddressSelectorWithGooglePlaces({
  countryRule,
  apiKey,
  className,
  onAddressSelected,
  searchInputId='find-address',
  address='',
  disabled = false,
  ...props
}) {
  const [query, setQuery] = useState(address);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (!apiKey || !countryRule || disabled) return;

    if (autocompleteRef.current) {
      autocompleteRef.current.setComponentRestrictions({ country: countryRule });
      return;
    }

    autocompleteRef.current = handleScriptLoad(searchInputId, countryRule, onAddressSelected, setQuery);
  }, [apiKey, countryRule, disabled]);

  useEffect(
    () => () => {
      const autocomplete = autocompleteRef.current;
      if (!autocomplete || !window.google?.maps?.event) return;
      window.google.maps.event.clearInstanceListeners(autocomplete);
      autocompleteRef.current = null;
    },
    []
  );

  return (
    <Styled className={classNames('AddressSelectorWithGooglePlaces', className)} {...props}>
      <Input
        id={searchInputId}
        name={searchInputId}
        value={query}
        allowClear
        disabled={disabled}
        onChange={(event) => {
          setQuery(event?.target?.value || '');
        }}
      />
    </Styled>
  );
}

AddressSelectorWithGooglePlaces.displayName = 'AddressSelectorWithGooglePlaces';
